import { toast } from 'react-hot-toast'

/**
 * Meldingen via de globale toast (react-hot-toast, de Toaster in de app-root).
 *
 * useToast() hield vroeger per aanroep een eigen lijst bij die alleen verscheen als het scherm
 * zijn ToastContainer renderde. Ca. 100 schermen en hooks deden dat nooit: hun meldingen waren
 * onzichtbaar (#694). Nu loopt elke melding door naar de ene Toaster; ToastContainer blijft
 * bestaan voor de schermen die hem renderen, maar tekent niets meer (anders kwam elke melding
 * dubbel). Een identieke melding van hetzelfde type vervangt de vorige in plaats van te stapelen.
 */
function toon(message, type, duration) {
  const opties = { id: `${type}:${message}` }
  if (typeof duration === 'number') opties.duration = duration
  if (type === 'success') return toast.success(message, opties)
  if (type === 'error') return toast.error(message, opties)
  if (type === 'warning') return toast(message, { ...opties, icon: '⚠️' })
  return toast(message, opties)
}

const GEEN_CONTAINER = () => null

// Een object voor alle aanroepers: stabiel, dus veilig in dependency-arrays van hooks.
const meldingen = {
  toasts: [],
  showToast: (message, type = 'info', duration) => toon(message, type, duration),
  removeToast: (id) => toast.dismiss(id),
  success: (message, duration) => toon(message, 'success', duration),
  error: (message, duration) => toon(message, 'error', duration),
  warning: (message, duration) => toon(message, 'warning', duration),
  info: (message, duration) => toon(message, 'info', duration),
  ToastContainer: GEEN_CONTAINER,
}

export function useToast() {
  return meldingen
}
